<script setup lang="ts">
import { LOGIN_URL } from '@/router'
import authApi from '@/services/auth.service'
import { decodeQueryParam } from '@/utils/queryUtils'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import PasswordView from './PasswordView.vue'

const route = useRoute()
const router = useRouter()

const queryParams = computed(() => ({
    token: route.query.token?.toString() ?? '',
    email: decodeQueryParam(route.query.email?.toString() ?? '')
}))

const goToLogin = () => router.replace(LOGIN_URL)
const submitCreation = (password: string, password_confirmation: string) => {
    if (!queryParams.value.email || !queryParams.value.token) return // TODO : Alerte
    authApi
        .resetPassword({
            ...queryParams.value,
            password,
            password_confirmation
        })
        .then(res => {
            if (res.status === 200) router.replace(LOGIN_URL)
            // TODO : Alerte
        })
}
</script>

<template>
    <PasswordView
        :title="$t('authentication.createPassword.title')"
        :primaryLabel="$t('authentication.submit')"
        :secondaryLabel="$t('authentication.backToLogin')"
        @clickSubmit="submitCreation"
        @clickSecondary="goToLogin">
        <template #title>
            <span class="bold">{{ queryParams.email }}</span>
        </template>
    </PasswordView>
</template>
